import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function setTaskListViewReducer(
	state = initialState.taskListView,
	action
) {
	switch (action.type) {
		case types.SET_TASK_LIST_VIEW: {
			let response = action.response;
			return {...state, ...action.taskListView};
		}
		default:
			return state;
	}
}
